const DonationSortBy = Object.freeze({
  AMOUNT: 'amount',
  DONATION_DATE: 'donation_date_string',
  METHOD: 'payment_type_enum',
  PLEDGE_DUE_DATE: 'pledge_due_date_string',
  TYPE: 'donation_type_enum',
});

export default DonationSortBy;
